import { render, staticRenderFns } from "./OpzioniOrdiniMTM.vue?vue&type=template&id=40266342&scoped=true"
import script from "./OpzioniOrdiniMTM.vue?vue&type=script&lang=ts"
export * from "./OpzioniOrdiniMTM.vue?vue&type=script&lang=ts"
import style0 from "./OpzioniOrdiniMTM.vue?vue&type=style&index=0&id=40266342&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40266342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40266342')) {
      api.createRecord('40266342', component.options)
    } else {
      api.reload('40266342', component.options)
    }
    module.hot.accept("./OpzioniOrdiniMTM.vue?vue&type=template&id=40266342&scoped=true", function () {
      api.rerender('40266342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/OpzioniOrdiniMTM.vue"
export default component.exports